import { Link, useLocation } from 'wouter'
import { selectionHaptic } from '@/lib/tg'
import { Icon } from './Icon'

const tabs = [
  { path: '/', label: 'Дом', icon: 'home' },
  { path: '/devices', label: 'Устройства', icon: 'devices' },
  { path: '/plans', label: 'Тарифы', icon: 'tag' },
  { path: '/profile', label: 'Профиль', icon: 'user' },
] as const

export function TabBar() {
  const [location] = useLocation()
  return (
    <nav className="sticky bottom-0 z-10 bg-[var(--color-bg)] border-t border-[var(--color-line)]"
      style={{ paddingBottom: 'max(env(safe-area-inset-bottom), 0px)' }}>
      <div className="grid grid-cols-4">
        {tabs.map((t) => {
          const active = t.path === '/' ? location === '/' : location.startsWith(t.path)
          return (
            <Link key={t.path} href={t.path} onClick={() => selectionHaptic()}
              className="tap relative flex flex-col items-center gap-1 py-2.5 pb-3"
              style={{ color: active ? 'var(--color-ink)' : 'var(--color-dim)' }}>
              {active && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 h-[3px] w-7 rounded-b-[2px]"
                  style={{ background: 'var(--color-accent)' }} />
              )}
              <Icon name={t.icon} size={20} />
              <span className="display text-[11px]">{t.label}</span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
